<div class="row">
    <div class="col-12">

        <div class="row" style="padding: 9px 22px;">
            <div class="col-12 stretch-card">
                <div class="col-3 no-padding" style="padding-right: 10px !important;">
                    {{ 'from' | localise }}<br/>
                    <angular2-date-picker
                            (onDateSelect)="onStartDateChange($event)"
                            [(ngModel)]="fromDate"
                            [settings]="settings"></angular2-date-picker>
                </div>
                <div class="col-3 no-padding" style="padding-left: 10px !important;">
                    {{ 'to' | localise }}<br/>
                    <angular2-date-picker
                            (onDateSelect)="onToDateChange($event)"
                            [(ngModel)]="toDate"
                            [settings]="settings"></angular2-date-picker>
                </div>
                <div class="col-6 no-padding" style="padding-left: 10px !important;">
                    Клиенти:<br/>

                    <ng-select [items]="clients"
                               [closeOnSelect]="false"
                               clearAllText="Изчисти"
                               [searchable]="true"
                               (change)="onChangeClients()"
                               bindLabel="name"
                               bindValue="id"
                               [(ngModel)]="selectedClientIds"
                               [multiple]="true">
                    </ng-select>
                </div>
            </div>
        </div>

        <ng-container *ngIf="diarySummary">

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">
                            Продукти ({{ diarySummary.groupedProductsByWeight.length }} бр.)
                        </h4>
                        <div class="table-responsive">
                            <table class="table table-striped scrollable-table">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Продукт</th>
                                    <th>Количество</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let product of diarySummary.groupedProductsByWeight; let i = index">
                                    <td>{{ (i + 1) }}</td>
                                    <td>{{ product.productTitleBg }}</td>
                                    <td>
                                        <ng-container *ngIf="product.typeCalculation == 'WEIGHT'">
                                            {{ numberKg(product.weight) }}
                                        </ng-container>

                                        <ng-container *ngIf="product.typeCalculation == 'QTY'">
                                            {{ numberWithSpaces(product.qty) }} бр.
                                        </ng-container>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">
                            Рецепти по дни и клиенти
                        </h4>

                        <ngb-accordion class="accordion accordion-solid-header"
                                       [closeOthers]="true"
                                       activeIds="panel-10">
                            <ngb-panel
                                    *ngFor="let groupRecipesByDate of diarySummary.recipesByDate"
                                    id="panel-{{ groupRecipesByDate.date }}"
                                    title="{{ groupRecipesByDate.date }}">
                                <ng-template ngbPanelContent>

                                    <div class="table-responsive">
                                        <table class="table table-striped scrollable-table">
                                            <thead>
                                            <tr>
                                                <th>Клиент</th>
                                                <th>Рецепти</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            <tr *ngFor="let groupedUser of Object.values(groupRecipesByDate.groupedByUser)">
                                                <td style="width: 150px;"
                                                    class="big-text">
                                                    {{ groupedUser.firstName }} {{ groupedUser.lastName }}
                                                </td>
                                                <td>
                                                    <table class="inner-table">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Хранене</th>
                                                            <th>Рецепта</th>
                                                            <th>Грамаж</th>
                                                            <th>Калории</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr *ngFor="let recipe of groupRecipesByMeal(groupedUser.recipes); let i = index;">
                                                            <td>{{ (i + 1) }}</td>
                                                            <td>
                                                                {{ recipe.meal.titleBg }}
                                                            </td>
                                                            <td class="big-text open-products" (click)="openRecipeProducts(recipe)">
                                                                {{ recipe.recipeTitleBg }}
                                                            </td>
                                                            <td>{{ numberKg(recipe.weight) }}</td>
                                                            <td>{{ numberWithSpaces(recipe.calories) }} kcal</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>


                    </div>
                </div>
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">
                            Рецепти по групи
                        </h4>

                        <ngb-accordion class="accordion accordion-solid-header"
                                       [closeOthers]="true"
                                       activeIds="panel-10">
                            <ngb-panel
                                    *ngFor="let groupedType of diarySummary.recipesByType"
                                    id="panel-{{ groupedType.type }}"
                                    title="{{ groupedType.type }}">
                                <ng-template ngbPanelContent>

                                    <div class="table-responsive">
                                        <table class="table table-striped scrollable-table">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Рецепта</th>
                                                <th>Грамаж</th>
                                                <th>Калории</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            <tr *ngFor="let recipe of groupedType.recipes; let i = index;">
                                                <td>{{ (i + 1) }}</td>
                                                <td class="big-text open-products" (click)="openRecipeProducts(recipe)">
                                                    {{ recipe.recipeTitleBg }}
                                                </td>
                                                <td>{{ numberKg(recipe.weight) }}</td>
                                                <td>{{ numberWithSpaces(recipe.calories) }} kcal</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>


                    </div>
                </div>
            </div>

        </ng-container>

    </div>
</div>
